<script setup lang="ts">
import type { GraphqlDatatableColumn } from '~/components/GqlDatatable.vue';
import { ref } from 'vue';
import { CompromissoForm } from '~/lib/fw';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const mostrarHistoricoSolicitacoes = ref<string>('h');
const colunas: GraphqlDatatableColumn[] = [
  {
    key: 'compromisso',
    title: 'COMPROMISSO',
    width: 120,
  },
  {
    key: 'responsavel',
    title: 'RESPONSÁVEL',
    width: 120,
  },
  {
    dataIndex: 'dataInicioText',
    key: 'dataInicio',
    sortBy: ['dataInicio'],
    sorter: true,
    title: 'SOLICITADO EM',
    width: 120,
    defaultSortOrder: 'descend',
  },
  {
    dataIndex: 'dataVencimentoText',
    key: 'dataVencimento',
    sortBy: ['dataVencimento'],
    sorter: true,
    title: 'VENCIMENTO EM',
    width: 120,
  },
  {
    dataIndex: 'dataConclusaoText',
    key: 'dataConclusao',
    sortBy: ['dataConclusao'],
    sorter: true,
    title: 'CONCLUÍDO EM',
    width: 120,
  },
];
</script>

<template>
  <CompromissoForm
    action="anexar-arquivos/enviar-arquivos"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    @close="() => emit('close')"
  >
    <template #form>
      <a-collapse
        v-if="props.pastaCodigos?.length === 1"
        v-model:active-key="mostrarHistoricoSolicitacoes"
        style="margin-bottom: 24px"
      >
        <a-collapse-panel key="h" header="HISTÓRICO DE SOLICITAÇÕES">
          <CompromissoGqlDatatable
            :columns="colunas"
            :show-dates-filter="false"
            :show-reload-button="false"
            :show-status-search-bar="false"
            :show-filter="false"
            :variables="{
              order: [{ dataInicio: 'DESC' }],
              where: {
                tipo: {
                  eq: 61,
                },
                fluxo: {
                  pastaCodigo: {
                    in: [props.pastaCodigos[0]],
                  },
                },
              },
            }"
          />
        </a-collapse-panel>
      </a-collapse>
      <a-alert
        message="Envie os arquivos que deseja anexar à pasta"
        show-icon
      />
    </template>
  </CompromissoForm>
</template>
